import { render, staticRenderFns } from "./overcoming.vue?vue&type=template&id=ef42e09e"
import script from "./overcoming.vue?vue&type=script&lang=js"
export * from "./overcoming.vue?vue&type=script&lang=js"
import style0 from "./overcoming.vue?vue&type=style&index=0&id=ef42e09e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports